var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isGoodsReceiptBatch ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('strong', [_vm._v("Er is geen gebatchte order om dit product aan toe te voegen.")]), _c('br'), _vm._v(" Leg apart voor plaatsing in loods. ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('success');
      }
    }
  }, [_vm._v("Voltooid")])], 1) : _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('strong', [_vm._v("Er is geen gebatchte order om dit product aan toe te voegen.")]), _c('br')]), _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('fail');
      }
    }
  }, [_vm._v("Volgende product")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }